import React, { useState, useEffect, useContext } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AuthCardLayout from "./AuthCardLayout";
import { all_routes } from "../router/all_routes";
import { API_BASE_URL } from "../../environment";
import { AuthContext } from "../../context/authcontext";

const MySwal = withReactContent(Swal);

const AccountVerification = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const route = all_routes;
  const { auth } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";

  useEffect(() => {
    if (auth) {
      navigate(route.dealsDashboard, { replace: true });
      return;
    }
  }, [auth, navigate, route.dealsDashboard]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleVerify();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleVerify = async () => {
    if (!token) {
      await MySwal.fire({
        icon: "error",
        title: "Verification Error",
        text: "Verification token is missing.",
        confirmButtonText: "OK",
      });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/signup-verification/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
      const data = await res.json();

      if (!res.ok) {
        if (data.error?.includes("Invalid or expired")) {
          const result = await MySwal.fire({
            icon: "error",
            title: "Link Expired",
            html: `
      <p>Your verification link is invalid or has expired.</p>
      <p>Click below to sign up again.</p>
    `,
            showConfirmButton: true,
            confirmButtonText: "Go to Sign Up",
            width: 450,
            customClass: {
              popup: "rounded-2xl p-4",
              title: "fs-24 fw-bold mb-2",
              htmlContainer: "fs-16 text-gray-700",
              confirmButton: "btn btn-primary w-100 mt-3",
            },
          });

          if (result.isConfirmed) {
            navigate(route.register);
          }
          return;
        }

        await MySwal.fire({
          icon: "error",
          title: "Verification Error",
          text: data.message || "Something went wrong. Please try again.",
          confirmButtonText: "OK",
        });
      } else {
        navigate(route.login);
      }
    } catch (err: any) {
      await MySwal.fire({
        icon: "error",
        title: "Network Error",
        text:
          err.message || "Unable to verify right now. Please try again later.",
        confirmButtonText: "OK",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCardLayout
      icon="ti-shield-check"
      title="Verify Your Account"
      subtitle={loading ? "Verifying your email address..." : "Please wait while we verify your email address."}
    >
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Verifying...</span>
        </div>
      </div>
    </AuthCardLayout>
  );
};

export default AccountVerification;
